import type { ErrorEvent, EventHint } from '@sentry/core';
import { env } from 'next-runtime-env';

import { isUnauthorizedHttpError } from '@/utils/isUnauthorizedHttpError';

/** Drop expected session / invalid-token failures (401 or API message). */
function beforeSend(event: ErrorEvent, hint?: EventHint): ErrorEvent | null {
  if (
    event.exception?.values?.some((e) => e.value?.includes('Invalid token'))
  ) {
    return null;
  }
  if (isUnauthorizedHttpError(hint?.originalException)) return null;

  return event;
}

export const getSentryCommonConfig = () => ({
  enabled:
    env('NEXT_PUBLIC_SENTRY_ENABLED') === 'true' &&
    !!env('NEXT_PUBLIC_SENTRY_DSN_URL'),
  environment: env('NEXT_PUBLIC_OURA_ENV'),
  release: env('NEXT_PUBLIC_VERSION') ?? 'local',
  dsn: env('NEXT_PUBLIC_SENTRY_DSN_URL'),

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  sendDefaultPii: false,

  beforeSend,
});
